import { useEffect, useState } from "react";
import { onUpdateAvailable, applyUpdate } from "../serviceWorker";
import { T } from "../tokens";

/**
 * Listens for a waiting service worker and shows a small prompt offering to
 * reload into the new version. Mounted at the top of the app tree so it's
 * always visible regardless of route.
 */
export default function UpdatePrompt() {
  const [available, setAvailable] = useState(false);
  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    return onUpdateAvailable(() => setAvailable(true));
  }, []);

  if (!available) return null;

  const onReload = () => {
    setReloading(true);
    applyUpdate(); // SW takes over → controllerchange → window.location.reload()
  };

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: "fixed",
        bottom: 24,
        right: 24,
        zIndex: 9999,
        background: T.dark3,
        border: `1px solid ${T.goldBdrS}`,
        borderRadius: 12,
        padding: "14px 18px",
        color: T.text,
        fontSize: 13.5,
        boxShadow: "0 8px 32px rgba(0,0,0,.6)",
        display: "flex",
        alignItems: "center",
        gap: 14,
        maxWidth: 360,
      }}
    >
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 600, color: T.goldLt, marginBottom: 2 }}>
          Update available
        </div>
        <div style={{ fontSize: 12.5, color: T.muted, lineHeight: 1.5 }}>
          A new version of Fayriza is ready. Reload to pick up the changes.
        </div>
      </div>
      <button
        onClick={onReload}
        disabled={reloading}
        style={{
          padding: "8px 14px",
          borderRadius: 8,
          background: `linear-gradient(135deg,${T.goldLt},${T.gold})`,
          border: `1px solid ${T.gold}`,
          color: T.dark,
          fontSize: 12.5,
          fontWeight: 600,
          cursor: reloading ? "wait" : "pointer",
          fontFamily: "inherit",
          flexShrink: 0,
        }}
      >
        {reloading ? "Reloading..." : "Reload"}
      </button>
      <button
        onClick={() => setAvailable(false)}
        aria-label="Dismiss update notice"
        style={{
          padding: "4px 8px",
          background: "transparent",
          border: "none",
          color: T.muted,
          fontSize: 18,
          cursor: "pointer",
          fontFamily: "inherit",
          lineHeight: 1,
        }}
      >
        ×
      </button>
    </div>
  );
}
